// @flow weak

import {GET, PUT} from '../helpers/request';
import {ADD as NOTIFICATION} from './notification';

export const GET_REQUEST = '@customerView/GET_REQUEST';
export const GET_SUCCESS = '@customerView/GET_SUCCESS';
export const GET_FAILURE = '@customerView/GET_FAILURE';

export const UPDATE_REQUEST = '@customerView/UPDATE_REQUEST';
export const UPDATE_SUCCESS = '@customerView/UPDATE_SUCCESS';
export const UPDATE_FAILURE = '@customerView/UPDATE_FAILURE';

export const TOGGLE_MENU = '@customerView/TOGGLE_MENU';
export const CLEAR = '@customerView/CLEAR';

const orderRequest = () => ({
  type: GET_REQUEST,
});

const orderSuccess = (order, project, apartment) => ({
  type: GET_SUCCESS,
  order,
  project,
  apartment,
});

const orderFailure = error => ({
  type: GET_FAILURE,
  error,
});

export const toggleMenu = show => ({
  type: TOGGLE_MENU,
  show,
});

export const clear = () => ({
  type: CLEAR,
});

const orderUpdateRequest = () => ({
  type: UPDATE_REQUEST,
});

const orderUpdateSuccess = order => ({
  type: UPDATE_SUCCESS,
  order,
  [NOTIFICATION]: {
    message: 'Beställning uppdaterad',
  },
});

const orderUpdateFailure = error => ({
  type: UPDATE_FAILURE,
  error,
});

export const fetchOrder = id => async dispatch => {
  dispatch(orderRequest());
  try {
    const order = await GET({endpoint: `/orders/${id}`}, dispatch);
    const apartment = await GET({endpoint: `/apartments/${order.apartmentId}`}, dispatch);
    const project = await GET({endpoint: `/projects/${apartment.projectId}`}, dispatch);
    dispatch(orderSuccess(order, project, apartment));
  } catch (err) {
    dispatch(orderFailure(err));
  }
};

export const updateOrder = (id, state) => async dispatch => {
  dispatch(orderUpdateRequest());
  try {
    const order = await PUT({
      endpoint: `/orders/${id}`,
      body: {state},
    }, dispatch);
    dispatch(orderUpdateSuccess(order));
  } catch (err) {
    dispatch(orderUpdateFailure(err));
  }
};



// WEBPACK FOOTER //
// ./src/actions/customerView.js